<template>
  <div> 
    <v-card flat class="custom-shadow mt-5">
      <v-card-text>
        <v-select
            v-model="ChartForSelected"
            :items="ChartForList"
            hide-details="auto"
            placeholder="Select time period"
            background-color="#f3f5f8"
            solo
            style="border-radius: 8px; width: 300px"
            flat
        />
        <div class="mt-5">
          <div v-if="this.datalist != null">
            <v-row class="mb-1">
              <v-col class="titleText--text font-weight-bold text-center" cols="2">Channel</v-col>
              <v-col class="titleText--text font-weight-bold text-center" cols="4">Spend ({{currency}})</v-col>
              <v-col class="titleText--text font-weight-bold text-center" cols="4">Incremental Sales ({{currency}})</v-col>
              <v-col class="titleText--text font-weight-bold text-left" cols="1"> ROI </v-col>
              <v-col class="titleText--text font-weight-bold text-left" cols="1"> Volume Response</v-col>
            </v-row>
            <div class="divscroll">
            <v-row  v-for="(item, index) in datalist" :key="index" >
              <v-col cols="2" class="titleText--text text-left" style="font-size: 14px">{{
                item.name
              }}</v-col>
              <v-col cols="4">
                <v-row>
                 
                  <v-col>
                    <v-progress-linear
                    v-model="item.SpendPerNew"
                      bg-color="white"
                    color="#e40046"
                    height="32"
                    rounded
                  >
   <strong class="titleText--text">{{ new Intl.NumberFormat('en-CA', {style: 'currency', currency}).format(item.SpendValue) }}</strong>
  </v-progress-linear>
                   </v-col
                  >
                 
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-row>
                  <v-col
                    
                  ><v-progress-linear
    v-model="item.IncPerNew"
    height="32"
     bg-color="cornsilk"
    color="#e40046"
    rounded
  >
   <strong class="titleText--text">{{ new Intl.NumberFormat('en-CA', {style: 'currency', currency}).format(item.IncrValue) }}</strong>
  </v-progress-linear>
  
                  </v-col>
                 
                </v-row>
              </v-col>
              <v-col cols="1">
                
                <v-chip label style="width: 100%" class="d-flex justify-center titleText--text font-weight-bold">{{ item.ROI }}</v-chip>
              </v-col>
              <v-col cols="1">
                <v-chip label style="width: 100%" class="d-flex justify-center titleText--text font-weight-bold">{{ item.volume_response }}</v-chip></v-col
              >
            </v-row></div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <div class="d-flex mt-5">
      <h2 class="titleText--text">Volume contribution</h2>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-icon  v-bind="attrs" size="medium"
          v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
        </template>
        <span> Volume contribution</span>
      </v-tooltip>
    </div>
    <v-card flat class="custom-shadow mt-2">
      <v-card-text>
        <div id="chart">
          <apexchart
            type="treemap"
            :options="chartOptions"
            :series="seriestemp"
          ></apexchart>
        </div>
      </v-card-text>
    </v-card>
    
    <div class="d-flex mt-5">
      <h2 class="titleText--text"> Opportunity for investment</h2>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon  v-bind="attrs" size="medium"
              v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
            </template>
            <span> Opportunity for investment</span>
          </v-tooltip>
        </div>
   <v-card flat class="custom-shadow mt-2">
      <v-card-title>
      </v-card-title>
      <v-card-text>
        <v-card flat color="rgb(243, 245, 248, .4)" class="mt-5">
          <ChartBubble ref="ctrlchartbubble" :ctrldataNew="this.ChartForSelected"></ChartBubble>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import apifactorynew from "../../api";
import VueApexCharts from "vue-apexcharts";
import ChartBubble from "./ModelOutComeBubbelChartNew.vue";
export default defineComponent({
  setup() {},
  components: { apexchart: VueApexCharts, ChartBubble },

  data: () => ({
    tempcols: parseInt((Math.ceil((0 / 1559943) * 100) * 12) / 100),
    tempcols2: 8,
    datalist: [],
    datalistforchart: [],
    resultdatafromapi: [],
    sumofspend: 0,
    sumofvalue: 0,
    Arraylistofsumofvalue: [],
    ChartForList: ["Total Period", "Current Period", "Previous Period"],
    ChartForSelected: "Total Period",
    // for maptree
    chartOptions: {
      legend: {
        show: false,
      },
      chart: {
        height: 200,
        type: "treemap",
      },
      title: {
        text: "",
        align: "center",
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: "12px",
        },
        formatter: function (text, op) {
          return [text, op.value + "%"];
        },
        offsetY: -4,
      },
      plotOptions: {
        treemap: {
          distributed: true,
          enableShades: false,
        },
      },
    },
    seriestemp: [],
  }),
  computed: {
    currency () {
      return localStorage.getItem('currency')
    }
  },
  methods: {
    getnewdataapicall_roi_total() {
      this.resultdatafromapi = [];
      this.seriestemp = [];
      this.datalistforchart = [];
      var alltempdata = [];
      var tempdatalist = [];
      var tempdatalist_roi = [];
      var tempdatalist_spend = [];
      var tempdatalist_incrsale = [];
      var tempdatalist_volume_response = [];

      this.sumofspend = 0;
      this.sumofvalue = 0;
      this.datalist = [];
      apifactorynew
        .get_model_outcome_str()
        .then((res) => {
          if (res.status != 200) {
            tempdatalist = null;
            // alert(this.processdataitems.length);
          } else {
            alltempdata = res.data.roi_total;
            this.resultdatafromapi = res.data.roi_total;
            tempdatalist = alltempdata.variable;
            tempdatalist_roi = alltempdata.roi;
            tempdatalist_spend = alltempdata.spend;
            tempdatalist_incrsale = alltempdata.value;
            tempdatalist_volume_response = alltempdata.volume_response;

            for (var k2 in tempdatalist) {
              if (tempdatalist_spend[k2] == null) {
                this.sumofspend = this.sumofspend + 0;
              } else {
                this.sumofspend = this.sumofspend + tempdatalist_spend[k2];

                // alert(this.sumofvalue);
              }
              if (tempdatalist_incrsale[k2] == null) {
                this.sumofvalue = this.sumofvalue + 0;
              } else {
                this.sumofvalue =
                  this.sumofvalue + parseFloat(tempdatalist_incrsale[k2]);
                this.Arraylistofsumofvalue.push(tempdatalist_incrsale[k2]);

                // alert(this.sumofvalue);
              }
            }
            this.sumofvalue = 0;
            this.sumofvalue = this.Arraylistofsumofvalue.reduce(
              (total, num) => total + num,
              0
            );
            //this.datalist = tempdatalist;
            for (var k1 in tempdatalist) {
              var objnew = new Object();

              objnew.name = tempdatalist[k1];
              if (tempdatalist_roi[k1] == null) {
                objnew.ROI = "NA";
              } else {
                objnew.ROI = tempdatalist_roi[k1];
              }

              if (tempdatalist_volume_response[k1] == null) {
                objnew.volume_response = "NA";
              } else {
                objnew.volume_response = tempdatalist_volume_response[k1];
              }

              objnew.SpendValue = tempdatalist_spend[k1];
              objnew.SpendPer = Math.ceil(
                (Math.ceil((objnew.SpendValue / this.sumofspend) * 100) * 12) /
                  100
              );
              objnew.SpendPerNew =objnew.SpendValue* 100 / this.sumofspend;
              objnew.IncrValue = tempdatalist_incrsale[k1];
              objnew.IncPer = Math.ceil(
                (Math.ceil((objnew.IncrValue / this.sumofvalue) * 100) * 12) /
                  100
              );  
              objnew.IncPerNew = (objnew.IncrValue* 100 / this.sumofvalue) ;
              this.datalist.push(objnew);
            }
            this.getnewdataapicall_roi_current_forchart();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getnewdataapicall_roi_current() {
      this.resultdatafromapi = [];
      this.seriestemp = [];
      this.datalistforchart = [];
      var alltempdata = [];
      var tempdatalist = [];
      var tempdatalist_roi = [];
      var tempdatalist_volume_response = [];
      var tempdatalist_spend = [];
      var tempdatalist_incrsale = [];

      this.sumofspend = 0;
      this.sumofvalue = 0;
      this.datalist = [];
      apifactorynew
        .get_model_outcome_str()
        .then((res) => {
          if (res.status != 200) {
            tempdatalist = null;
            // alert(this.processdataitems.length);
          } else {
            alltempdata = res.data.roi_current;
            this.resultdatafromapi = res.data.roi_current;
            tempdatalist = alltempdata.variable;
            tempdatalist_roi = alltempdata.roi;
            tempdatalist_volume_response = alltempdata.volume_response;
            tempdatalist_spend = alltempdata.spend;
            tempdatalist_incrsale = alltempdata.value;

            for (var k2 in tempdatalist) {
              if (tempdatalist_spend[k2] == null) {
                this.sumofspend = this.sumofspend + 0;
              } else {
                this.sumofspend = this.sumofspend + tempdatalist_spend[k2];

                // alert(this.sumofvalue);
              }
              if (tempdatalist_incrsale[k2] == null) {
                this.sumofvalue = this.sumofvalue + 0;
              } else {
                this.sumofvalue =
                  this.sumofvalue + parseFloat(tempdatalist_incrsale[k2]);
                this.Arraylistofsumofvalue.push(tempdatalist_incrsale[k2]);

                // alert(this.sumofvalue);
              }
            }
            this.sumofvalue = 0;
            this.sumofvalue = this.Arraylistofsumofvalue.reduce(
              (total, num) => total + num,
              0
            );
            //this.datalist = tempdatalist;
            for (var k1 in tempdatalist) {
              var objnew = new Object();

              objnew.name = tempdatalist[k1];
              if (tempdatalist_roi[k1] == null) {
                objnew.ROI = "NA";
              } else {
                objnew.ROI = tempdatalist_roi[k1];
              }

              if (tempdatalist_volume_response[k1] == null) {
                objnew.volume_response = "NA";
              } else {
                objnew.volume_response = tempdatalist_volume_response[k1];
              }

              objnew.SpendValue = tempdatalist_spend[k1];
              objnew.SpendPer = Math.ceil(
                (Math.ceil((objnew.SpendValue / this.sumofspend) * 100) * 12) /
                  100
              );
             objnew.SpendPerNew =objnew.SpendValue* 100 / this.sumofspend;
              objnew.IncrValue = tempdatalist_incrsale[k1];
              objnew.IncPer = Math.ceil(
                (Math.ceil((objnew.IncrValue / this.sumofvalue) * 100) * 12) /
                  100
              );
              objnew.IncPerNew = (objnew.IncrValue* 100 / this.sumofvalue) ;

              this.datalist.push(objnew);
            }
            this.getnewdataapicall_roi_current_forchart();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    getnewdataapicall_roi_previous() {
      this.resultdatafromapi = [];
      this.seriestemp = [];
      this.datalistforchart = [];
      var alltempdata = [];
      var tempdatalist = [];
      var tempdatalist_roi = [];
      var tempdatalist_spend = [];
      var tempdatalist_incrsale = [];
      var tempdatalist_volume_response = [];
      this.sumofspend = 0;
      this.sumofvalue = 0;
      this.datalist = [];
      apifactorynew
        .get_model_outcome_str()
        .then((res) => {
          if (res.status != 200) {
            tempdatalist = null;
            // alert(this.processdataitems.length);
          } else {
            alltempdata = res.data.roi_previous;
            this.resultdatafromapi = res.data.roi_previous;
            tempdatalist = alltempdata.variable;
            tempdatalist_roi = alltempdata.roi;
            tempdatalist_spend = alltempdata.spend;
            tempdatalist_incrsale = alltempdata.value;
            tempdatalist_volume_response = alltempdata.volume_response;

            for (var k2 in tempdatalist) {
              if (tempdatalist_spend[k2] == null) {
                this.sumofspend = this.sumofspend + 0;
              } else {
                this.sumofspend = this.sumofspend + tempdatalist_spend[k2];

                // alert(this.sumofvalue);
              }
              if (tempdatalist_incrsale[k2] == null) {
                this.sumofvalue = this.sumofvalue + 0;
              } else {
                this.sumofvalue =
                  this.sumofvalue + parseFloat(tempdatalist_incrsale[k2]);
                this.Arraylistofsumofvalue.push(tempdatalist_incrsale[k2]);

                // alert(this.sumofvalue);
              }
            }
            this.sumofvalue = 0;
            this.sumofvalue = this.Arraylistofsumofvalue.reduce(
              (total, num) => total + num,
              0
            );
            //this.datalist = tempdatalist;
            for (var k1 in tempdatalist) {
              var objnew = new Object();

              objnew.name = tempdatalist[k1];
              if (tempdatalist_roi[k1] == null) {
                objnew.ROI = "NA";
              } else {
                objnew.ROI = tempdatalist_roi[k1];
              }

              if (tempdatalist_volume_response[k1] == null) {
                objnew.volume_response = "NA";
              } else {
                objnew.volume_response = tempdatalist_volume_response[k1];
              }

              objnew.SpendValue = tempdatalist_spend[k1];
              objnew.SpendPer = Math.ceil(
                (Math.ceil((objnew.SpendValue / this.sumofspend) * 100) * 12) /
                  100
              ); 
             objnew.SpendPerNew =objnew.SpendValue* 100 / this.sumofspend;
              objnew.IncrValue = tempdatalist_incrsale[k1];
              objnew.IncPer = Math.ceil(
                (Math.ceil((objnew.IncrValue / this.sumofvalue) * 100) * 12) /
                  100
              );
               objnew.IncPerNew = (objnew.IncrValue* 100 / this.sumofvalue) ;
              this.datalist.push(objnew);
            }
            this.getnewdataapicall_roi_current_forchart();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    // for maptree chart
    getnewdataapicall_roi_current_forchart() {
      this.seriestemp = [];
      this.datalistforchart = [];
      var tempdatalistchart = [];
      var tempdatalist_volume_contribution_chart = [];
      tempdatalistchart = this.resultdatafromapi.variable;
      //alert(JSON.stringify(tempdatalistchart));
      tempdatalist_volume_contribution_chart =
        this.resultdatafromapi.volume_contribution;
      //alert(JSON.stringify(this.resultdatafromapi.variable));
      for (var k1 in tempdatalistchart) {
        var objnew1 = new Object();

        objnew1.x = tempdatalistchart[k1];

        if (tempdatalist_volume_contribution_chart[k1] == null) {
          objnew1.y = tempdatalist_volume_contribution_chart[k1]; // "0";
        } else {
          objnew1.y = tempdatalist_volume_contribution_chart[k1];
        }

        this.datalistforchart.push(objnew1);
      }
      var objnewseries1 = new Object();
      objnewseries1.data = this.datalistforchart.filter((a) => a.y != 0);
      this.seriestemp.push(objnewseries1);
    },
    binddata() {
      //alert('binddata');
      if (this.ChartForSelected == "Total Period") {
        this.getnewdataapicall_roi_total();
      }
      if (this.ChartForSelected == "Current Period") {
        this.getnewdataapicall_roi_current();
      }
      if (this.ChartForSelected == "Previous Period") {
        this.getnewdataapicall_roi_previous();
      }
      
      //this.$refs.ctrlchartbubble.ctrldata='ddd';
    },
  },
  mounted() {
    this.binddata();
    // this.binddata();
  },
  watch: {
    ctrldatanew: function (val) {
      alert("Onoad -" + val);
    },
  },
});
</script>
<style scoped>
.roidiv {
  border-style: solid;
  border-color: black;
  border-width: 1px;
  /*margin: 5% 5% 5% 5%;*/
  padding: 2 2 2 2%;
  text-align: center;
  vertical-align: middle;
}
.namediv {
  padding: 5 5 5 5%;
  text-align: left;
  padding-right: 2%;
}
.progressbar {
  background-color: #e40046;
  color: white;
  text-align: right;
  margin-top: 2%;
  margin-bottom: 2%;
  border-style: solid;
  border-color: black;
  border-width: 1px;
}
.progressbar-new {
  background-color: #e40046;
  color: white;
  text-align: left;
}
.progressbar-row {
  background-color:cornsilk;
  color: white;
  text-align: left;
}
.progressbar-values {
  text-align: right;
  padding: 2 2 2 2%;
  font-size: 9px;

  vertical-align: middle;
}
.progressbar-text {
  text-align: left;
}
.tablecellspace {
  padding-right: 5px;
}
.tablecellheader {
  color: black;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 10%;
  text-align: center;
  font-size: 12px;
}
.divscroll{
  overflow-y: auto;
  overflow-x: hidden;
  height: 400px;
  padding-left: 10px;
  padding-right: 10px;

}
</style>
